/**
 * Set the height of a html element at the scope, uses the id field
 */
angular.module('impactx.product').directive('ixSetHeight', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            scope.$watch('content', function()
            {
                var height = {};
                height.height = element[0].offsetHeight;
                scope[element.attr('id')] = height;
            });
        }
    }
});